import React, { useEffect, useState } from 'react';
import './ShortlistDettaglio.scss';
import { useParams } from 'react-router-dom'
import { Formik, Form, FormikHelpers as FormikActions } from 'formik';
import { isEqual } from 'lodash';
import { DragDropContext, Draggable, Droppable, DropResult } from 'react-beautiful-dnd';

import { PermissionDenied, useWebsocket, WebSocketState } from 'django-rest-react'
import { ThreadLista } from '../api/types'
import {
  patch_versione_shortlist, refresh_shortlist, refresh_thread_problema_list,
  connectModificaShortlist,
} from '../api'
import {
  displayEvento, array_remove as remove, sentry_log, displayBadgeStatoShortlist,
} from '../utils'
import {
  LoadingCircle, Partecipante as PartecipanteComp,
  TimeFeedShortlist, ConfirmedButton, FormGroupBootstrap, NuovoCommento,
  ErrorBlockGeneric
} from '../components'
import { correzioni_richieste, STATO_SHORTLIST, canSeeShortlist, login_url } from '../globals';
import store from '../store'
import { add_toast_action } from '../actions'
import { useLogin, useShortlist, useCategoria, useThread, useEvento, useCompetenza } from '../reducers';
import { post_thread_shortlist_detail_assegna_evento } from '../api/auto-apis';
import TabellaProblemi, { SHORTLIST_COLUMNS } from '../components/TabellaProblemi';
import ProblemiEsclusiShortlist from '../components/ProblemiEsclusiShortlist';
import EsportaShortlist from '../components/EsportaShortlist';
import StatisticheShortlist from '../components/StatisticheShortlist';
import PresenzeShortlist from '../components/PresenzeShortlist';


interface FormValues {
  ordine: string,
  stato: 'a' | 'p' | 'r'
}

interface ThreadListaOrdinato extends ThreadLista {
  ordine: number
}


function reorder<T>(list: T[], startIndex: number, endIndex: number) {
  const result = Array.from(list);
  const [removed] = result.splice(startIndex, 1);
  result.splice(endIndex, 0, removed);
  return result;
};


const ShortlistDettaglio = (props: {}) => {

  const [connessi, setConnessi] = useState<number[]>([]);
  const [error, setError] = useState(null);
  const [commenta, setCommenta] = useState(false);
  const [mostraEsclusi, setMostraEsclusi] = useState<boolean | null>(null);

  const threads = useThread(props);
  const login = useLogin();
  const shortlists = useShortlist(props);
  const categorie = useCategoria(props);
  const eventi = useEvento(props);
  const competenze = useCompetenza(props);

  const wss = useWebsocket();
  const connectionState = wss.current.wss;
  useEffect(() => {
    if (connectionState !== WebSocketState.Connected) {
      setConnessi(people => people.length ? [] : people);
    }
  }, [connectionState]);
  const params = useParams<{ pk: string }>();

  useEffect(() => {
    document.title = `Shortlist #${params.pk} - Owlitrack`;
  }, [])


  if (!login.logged_in) {
    login_url()
  }
  if (!canSeeShortlist(login.user)) {
    throw new PermissionDenied({ message: "Non hai abbastanza permessi per vedere le shortlist." })
  }

  // TODO: Rendere size inseribile da form
  const pk = parseInt(params.pk as string);
  const thread = shortlists.find(item => item.id === pk);
  if (!thread) {
    return <LoadingCircle />
  }
  const { shortlist } = thread;
  const last = shortlist.versioni[shortlist.versioni.length - 1]
  const savedProblemIds = new Set(last.lista_problemi);
  const hasUnassignedSavedProblem = threads.some(thread =>
    savedProblemIds.has(thread.problema.id) && thread.problema.evento_assegnato === null);
  const initialValues = {
    ordine: last.ordine,
    stato: last.stato
  }
  return (
    <div className="container shortlist-detail">
      <h1 className="page-header">{shortlist.titolo}</h1>
      {shortlist.evento &&
        <h3>{`Shortlist per l'evento ${displayEvento(shortlist.evento)}`}</h3>}
      <Formik
        initialValues={initialValues} onSubmit={(values: FormValues, actions: FormikActions<FormValues>) => {
          const submitting_values = {
            versioni: [
              {
                stato: values.stato,
                ordine: values.ordine,
              }
            ],
          }
          const thread = shortlists.find(item => item.id === pk);
          if (!thread) {
            sentry_log(new Error("Non trovo il thread per submittare la shortlist"))
            actions.setSubmitting(false);
            return;
          }
          const { shortlist } = thread;
          setError(null);
          return patch_versione_shortlist(shortlist.id, submitting_values)
            .then(async () => {
              await refresh_shortlist();
              store.dispatch(add_toast_action({
                title: "Modifiche salvate sul server",
                message: <>
                  <p>Le modifiche sono state correttamente salvate sul server</p>
                </>
              }))
            })
            .catch(error => {
              sentry_log(error)
              setError(error)
              actions.setErrors(error);
            })
            .finally(() => actions.setSubmitting(false));
        }
        }
        enableReinitialize={true}
      >
        {({ values, isSubmitting, setFieldValue, handleReset }) => {
          useEffect(() => {
            return connectModificaShortlist(
              wss.current, shortlist.id,
              ordine => setFieldValue("ordine", ordine),
              setConnessi
            )
          }, [shortlist.id])

          const __appo_ws = wss.current.ws;
          const setOrdineAndNotify = (nuovo_ordine: string) => {
            setFieldValue("ordine", nuovo_ordine);
            if (wss.current.wss == WebSocketState.Connected) {
              __appo_ws.send(JSON.stringify({
                type: "new_ordine", ordine: nuovo_ordine
              }))
            }
          };

          const modificato = !isEqual(values, initialValues);
          const lista_problemi = values.ordine ?
            values.ordine.split(',').map(item => parseInt(item)) :
            []
          const primi_n_ = lista_problemi.map(
            (item, idx) => {
              const appo = threads.find(pitem => pitem.id == item)
              if (!appo) {
                return null
              }
              return { ...appo, ordine: idx + 1 };
            });
          const missing_threads = primi_n_.reduce((acc, item) => acc || (item === null), false);
          const primi_n = missing_threads ? [] : primi_n_ as ThreadListaOrdinato[];
          const onDragEnd = (result: DropResult) => {
            if (!result.destination) {
              return;
            }
            setOrdineAndNotify(reorder(
              lista_problemi,
              result.source.index,
              result.destination.index,
            ).join(","));
          }


          let esclusi;
          let extra_message = "(tutti gli altri problemi)"
          if (shortlist.parent) {
            const pparent = shortlists.find(item => item.shortlist &&
              item.shortlist.id == shortlist.parent);
            if (!pparent) {
              return <LoadingCircle />
            }
            extra_message = `(dalla shortlist ${pparent.titolo})`
            const parent = pparent.shortlist;
            const last = parent.versioni[parent.versioni.length - 1]
            const nuova_lista = last.ordine.split(",").map(item => parseInt(item))
            esclusi = threads
              .filter(item => nuova_lista.includes(item.id))
              .filter(item => !lista_problemi.includes(item.id))

          } else {
            esclusi = threads.filter(item => !lista_problemi.includes(item.id))

          }
          const data_evento = eventi.find(ev => ev.id === shortlist.evento)?.data
          const evento_passato = !!data_evento ? (new Date(data_evento).getTime()) < (new Date().getTime()) : false;
          return (
            <>
              <Form className="shortlist-action-bar" aria-label="Stato e salvataggio shortlist" aria-busy={isSubmitting}>
                <div className="shortlist-save-summary">
                  <div className="d-flex flex-wrap align-items-center shortlist-saved-version">
                    <span className="small text-muted">Versione salvata #{last.num ?? shortlist.versioni.length}</span>
                    {displayBadgeStatoShortlist(last.stato)}
                  </div>
                  <p className={`shortlist-save-state ${isSubmitting ? 'text-info' : modificato ? 'text-warning' : 'text-success'}`}
                    role="status" aria-live="polite">
                    <i className={`fa ${isSubmitting ? 'fa-spinner fa-spin' : modificato ? 'fa-pencil' : 'fa-check'} mr-1`} aria-hidden="true" />
                    {isSubmitting ? 'Salvataggio in corso…' : modificato ? 'Modifiche non salvate' : 'Nessuna modifica da salvare'}
                  </p>
                  <p className="shortlist-connection small text-muted mb-0">
                    <i className={`fa fa-circle mr-1 ${wss.current.wss === WebSocketState.Connected ? 'text-success' : 'text-warning'}`} aria-hidden="true" />
                    {wss.current.wss === WebSocketState.Connected ? 'Collaborazione connessa' : 'Collaborazione non connessa'}
                  </p>
                </div>
                <div className="shortlist-action-controls">
                  <FormGroupBootstrap name="stato" type="select" choices={STATO_SHORTLIST}
                    displayName="Stato della nuova versione" disabled={isSubmitting} />
                  <div className="shortlist-save-buttons">
                    <ConfirmedButton type="warning" disabled={isSubmitting || !modificato} onSubmit={handleReset}>
                      Annulla modifiche
                    </ConfirmedButton>
                    <button className="btn btn-primary" type="submit" disabled={isSubmitting || !modificato}>
                      Salva una nuova versione
                    </button>
                  </div>
                </div>
                <p className="shortlist-save-help small text-muted mb-0">
                  {wss.current.wss === WebSocketState.Connected
                    ? 'Le modifiche all’ordine sono condivise in diretta. Per salvarle, crea una nuova versione.'
                    : 'La condivisione in diretta non è disponibile. Puoi comunque salvare una nuova versione.'}
                </p>
                {error && <div className="shortlist-save-error" role="alert"><ErrorBlockGeneric error={error} /></div>}
              </Form>
              <PresenzeShortlist participants={connessi} currentParticipantId={login.user.id}
                connected={wss.current.wss === WebSocketState.Connected} />
              {evento_passato && hasUnassignedSavedProblem &&
                <div className="card">
                  <div className="card-header">
                    <h4 className="card-title">Assegna ad evento</h4>
                    <p>L’evento è passato e alcuni problemi della versione salvata non sono ancora assegnati.
                      Vuoi assegnare i problemi della versione salvata a questo evento?</p>
                    <ConfirmedButton type="danger" onSubmit={() => post_thread_shortlist_detail_assegna_evento(pk, {} as any)
                      .then(() => refresh_thread_problema_list())
                      .catch(error => { sentry_log(error); setError(error); })}>Assegna</ConfirmedButton>
                  </div>

                </div>
              }
              {shortlist.extra_contributors.length > 0 &&
                <div className="card mb-2">
                  <div className="card-header">
                    <h4 className="card-title">Collaboratori esterni</h4>
                  </div>
                  <div className="card-body">
                    <div className="d-flex flex-wrap my-1">{shortlist.extra_contributors.map(item =>
                      <PartecipanteComp
                        key={item} partecipante={item}
                      />)}
                    </div>
                  </div>
                </div>
              }

              <EsportaShortlist threadId={pk} savedVersion={last.num ?? shortlist.versioni.length} modified={modificato} />
              <StatisticheShortlist threads={primi_n} selectedCount={lista_problemi.length} categories={categorie} skills={competenze}
                requiredCorrections={correzioni_richieste} modified={modificato} savedVersion={last.num ?? shortlist.versioni.length} />
              <div>
                <TabellaProblemi threads={primi_n} columns={SHORTLIST_COLUMNS} ratings="visible" sortable={false}
                  leadingColumn={{ header: 'Ordine di preferenza', render: (_, index) => index + 1 }}
                  actionColumn={{ header: 'Elimina', render: (_, index) => (
                    <button type="button" className="btn btn-danger" title="Elimina" aria-label={`Elimina problema ${primi_n[index].id}`}
                      onClick={() => setOrdineAndNotify(remove(lista_problemi, index).join(','))}>
                      <i className="fa fa-times" aria-hidden="true" />
                    </button>
                  ) }}
                  renderBody={rows => <DragDropContext onDragEnd={onDragEnd}>
                    <Droppable droppableId="problemi_shortlist">{provided => (
                      <tbody {...provided.droppableProps} ref={provided.innerRef}>
                        {rows}{provided.placeholder}
                      </tbody>
                    )}</Droppable>
                  </DragDropContext>}
                  renderRow={(item, index, cells) => (
                    <Draggable key={item.id * 10000 + index} draggableId={item.id.toString()} index={index}>
                      {provided => <tr ref={provided.innerRef} {...provided.draggableProps} {...provided.dragHandleProps}>{cells}</tr>}
                    </Draggable>
                  )}
                />

              </div>
              <h1>Problemi esclusi {extra_message}</h1>
              <button className="btn btn-info my-1" type="button" aria-expanded={!!mostraEsclusi}
                aria-controls="shortlist-candidates" onClick={() => setMostraEsclusi(m => !m)}>
                Toggle visualizzazione (è ingombrante)
              </button>
              {mostraEsclusi !== null && <div id="shortlist-candidates" hidden={!mostraEsclusi}>
                <ProblemiEsclusiShortlist
                  esclusi={esclusi} lista_problemi={lista_problemi}
                  setOrdineAndNotify={setOrdineAndNotify}
                />
              </div>}

              <h1>Discussione</h1>
              <TimeFeedShortlist versioni={shortlist.versioni} threadpk={pk} />
              <div className="d-flex justify-content-between">
                <button
                  className="btn btn-primary" type="button"
                  onClick={() => setCommenta(c => !c)}
                >
                  Commenta
                </button>
              </div>
              {commenta && <NuovoCommento thread={pk} />}
            </>)
        }}
      </Formik>
    </div>
  );
}


export default ShortlistDettaglio;
